module.exports = __webpack_public_path__ + "img/home.93bc8797.png";